import { useI18n } from 'i18n/hooks/useI18n';

import { ListingRichTextHolder } from './ListingRichText.styled';

type Props = {
  content: string;
};

export function ListingRichText({ content }: Props) {
  const { i18n } = useI18n();

  return (
    <ListingRichTextHolder
      dangerouslySetInnerHTML={{ __html: content }}
      $bodyText={i18n('Body')}
      $headlineText={i18n('Headline')}
    />
  );
}
